import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';

import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const FixturePenalties = ({ fixturePrediction, includeHome, includeAway }) => {
    if (!fixturePrediction) {
        return null;
    }

    const home = fixturePrediction?.teams?.home;
    const away = fixturePrediction?.teams?.away;

    const getTeamTitle = (team) => {
        return (
            <Box style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <CustomTeamImageWithDefault
                    teamId={team.id}
                    alt={team.name}
                    width={20}
                    height={20}
                ></CustomTeamImageWithDefault>
                <Typography component={'span'}>{team?.name}</Typography>
            </Box>
        );
    };

    const getTable = (team) => {
        return (
            <TableContainer component={Paper} className="datos-table-container mb-25">
                <Table className="data-table-penaltis" size={'small'} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="first-row title-tabs">{getTeamTitle(team)}</TableCell>
                            <TableCell className="table-row"></TableCell>
                            <TableCell className="table-row"></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="first-row" style={{ fontWeight: '600' }}>
                                Penaltis
                            </TableCell>
                            <TableCell className="table-row text" style={{ fontWeight: '600' }}>
                                Total
                            </TableCell>
                            <TableCell className="table-row text" style={{ fontWeight: '600' }}>
                                Porcentaje
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell className="first-row">Anotados</TableCell>
                            <TableCell className="table-row">
                                {team?.league?.penalty?.scored?.total ?? '-'}
                            </TableCell>
                            <TableCell className="table-row">
                                {team?.league?.penalty?.scored?.percentage ?? '-'}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="first-row">Fallados</TableCell>
                            <TableCell className="table-row">
                                {team?.league?.penalty?.missed?.total ?? '-'}
                            </TableCell>
                            <TableCell className="table-row">
                                {team?.league?.penalty?.missed?.percentage ?? '-'}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <>
            {includeHome && getTable(home)}
            {includeAway && getTable(away)}
        </>
    );
};

export default FixturePenalties;
